module.exports = __webpack_public_path__ + "static/media/51.981a0aed.wav";